import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import Loader from '../../../../component/common/Loader'
import Topbar from '../../../PulseSurvey/Topbar';
import { Link, useNavigate } from 'react-router-dom';
import SearchInput from '../../../../component/common/Input/SearchInput';
import { Calendar } from 'react-date-range';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import { useRef } from 'react';
import { errorToast, useOutsideClick } from '../../../../utils/helper';
import DashboardInfoCard from '../../../../component/common/DashboardInfoCard';
import Pagination from '../../../../component/common/table2/Pagination';
import Table from '../../../../component/common/Table';
import { Api } from '../../../../api';
import { CompanyApi } from '../../../../api/companyApi';

const B2cUsers = () => {
    const [loader, setLoader] = useState(false);
    const selectedTheme = JSON.parse(localStorage.getItem('selectedTheme'));
    const [searchTerm, setSearchTerm] = useState('');
    const [debounceTimeout, setDebounceTimeout] = useState(null);
    const ref2 = useRef(null);
    const calendarRef = useRef(null);
    const [isOpen2, setIsOpen2] = useState(false);
    const [startDate, setStartDate] = useState('');
    const navigate = useNavigate();
    const userData = JSON.parse(localStorage.getItem('userData'));
    const [companyUsers, setCompanyUsers] = useState([]);
    const [clickedCompanyBadges, setClickedCompanyBadges] = useState([]);
    const [clickedRowId, setClickedRowId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [dashStates, setDashStates] = useState({});
    const [apiCall, setApiCall] = useState(true);

    const handleChangeC = (e) => {
        const date = new Date(e);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setStartDate(formattedDate);
        // handlePagination(1, selectedPerPage.value, searchTerm, sortBy, sortOrder, formattedDate);
        setIsOpen2(false);
    };
    useOutsideClick(calendarRef, () => {
        setIsOpen2(false);
    });
    const subAdminStatusCards = [
        <DashboardInfoCard
            icon={
                <svg
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="56" height="56" rx="28" fill="#E5EAF9" />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M41.7961 27.7097C41.4361 26.2591 40.6161 24.9607 39.4548 24.0114C38.2164 22.9994 36.6663 22.4465 35.0672 22.4465C33.4679 22.4465 31.9178 22.9994 30.6796 24.0114C30.4099 24.2318 30.1587 24.4711 29.9273 24.7266C31.358 24.9862 32.748 25.6024 33.8809 26.7353C34.3083 27.1627 34.6622 27.6267 34.9511 28.1157C37.2245 28.1205 39.4972 27.9852 41.7961 27.7097Z"
                        fill="#B6C0F3"
                    />
                    <path
                        d="M32.5938 38.0958C33.7551 39.0451 34.5753 40.3436 34.9352 41.7941C34.9352 41.7941 30.8665 42.3245 28.2063 42.3245C25.546 42.3245 21.4774 41.7941 21.4774 41.7941C21.8373 40.3436 22.6574 39.0451 23.8187 38.0958C25.057 37.0839 26.607 36.5309 28.2063 36.5309C29.8055 36.5309 31.3556 37.0839 32.5938 38.0958Z"
                        fill="#B6C0F3"
                    />
                    <path
                        d="M28.2045 36.5303C30.8418 36.5303 32.3253 35.0468 32.3253 32.4095C32.3253 29.7722 30.8418 28.2887 28.2045 28.2887C25.5671 28.2887 24.0836 29.7722 24.0836 32.4095C24.0836 35.0468 25.5671 36.5303 28.2045 36.5303Z"
                        fill="#B6C0F3"
                    />
                    <path
                        d="M34.9352 41.7941C34.5753 40.3436 33.7551 39.0451 32.5938 38.0958C31.3556 37.0837 29.8055 36.5309 28.2063 36.5309C26.607 36.5309 25.057 37.0837 23.8187 38.0958C22.6574 39.0451 21.8373 40.3436 21.4774 41.7941"
                        stroke="#313B6B"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M28.2045 36.5303C30.8418 36.5303 32.3253 35.0468 32.3253 32.4095C32.3253 29.7722 30.8418 28.2887 28.2045 28.2887C25.5671 28.2887 24.0836 29.7722 24.0836 32.4095C24.0836 35.0468 25.5671 36.5303 28.2045 36.5303Z"
                        stroke="#313B6B"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M35.0671 22.446C37.7044 22.446 39.1879 20.9625 39.1879 18.3252C39.1879 15.6878 37.7044 14.2043 35.0671 14.2043C32.4296 14.2043 30.9461 15.6878 30.9461 18.3252C30.9461 20.9625 32.4296 22.446 35.0671 22.446Z"
                        fill="#B6C0F3"
                    />
                    <path
                        d="M35.0671 22.446C37.7044 22.446 39.1879 20.9625 39.1879 18.3252C39.1879 15.6878 37.7044 14.2043 35.0671 14.2043C32.4296 14.2043 30.9461 15.6878 30.9461 18.3252C30.9461 20.9625 32.4296 22.446 35.0671 22.446Z"
                        stroke="#313B6B"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M41.7937 27.7097C41.4338 26.2591 40.6138 24.9607 39.4524 24.0114C38.2143 22.9994 36.6642 22.4465 35.0648 22.4465C33.4657 22.4465 31.9156 22.9994 30.6773 24.0114"
                        stroke="#313B6B"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.2055 27.7097C14.5654 26.2591 15.3855 24.9607 16.5468 24.0114C17.7851 22.9994 19.3351 22.4465 20.9344 22.4465C22.5336 22.4465 24.0837 22.9994 25.3219 24.0114C25.5916 24.2318 25.8428 24.4711 26.0742 24.7266C24.6435 24.9862 23.2535 25.6024 22.1206 26.7353C21.6932 27.1627 21.3394 27.6267 21.0504 28.1157C18.7771 28.1205 16.5043 27.9852 14.2055 27.7097Z"
                        fill="#B6C0F3"
                    />
                    <path
                        d="M20.9357 22.446C18.2983 22.446 16.8148 20.9625 16.8148 18.3252C16.8148 15.6878 18.2983 14.2043 20.9357 14.2043C23.5731 14.2043 25.0566 15.6878 25.0566 18.3252C25.0566 20.9625 23.5731 22.446 20.9357 22.446Z"
                        fill="#B6C0F3"
                    />
                    <path
                        d="M20.9357 22.446C18.2983 22.446 16.8148 20.9625 16.8148 18.3252C16.8148 15.6878 18.2983 14.2043 20.9357 14.2043C23.5731 14.2043 25.0566 15.6878 25.0566 18.3252C25.0566 20.9625 23.5731 22.446 20.9357 22.446Z"
                        stroke="#313B6B"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M14.2055 27.7097C14.5654 26.2591 15.3855 24.9607 16.5468 24.0114C17.7851 22.9994 19.3351 22.4465 20.9344 22.4465C22.5336 22.4465 24.0837 22.9994 25.3219 24.0114"
                        stroke="#313B6B"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            }
            title={'Total Accounts'}
            value={dashStates?.totalAccounts}
        />,
        <DashboardInfoCard
            icon={
                <svg
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="56" height="56" rx="28" fill="#E5EAF9" />

                    <g transform="translate(12, 12)">
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.5848 18.458C4.83034 13.717 -1.46276 2.2043 16.0011 2.2043C33.4632 2.2043 27.1731 13.7145 23.4186 18.4564C22.7044 16.4418 21.2808 15.0534 19.233 14.377C20.277 12.4681 20.8045 10.9997 20.9888 9.45708C19.0618 9.06947 17.5451 8.90068 16.0011 8.92167C14.4571 8.90068 12.9404 9.06947 11.0135 9.45708C11.1978 10.9999 11.7253 12.4683 12.7695 14.3775C10.7219 15.0543 9.29852 16.4429 8.5848 18.458Z"
                            fill="#B6C0F3"
                        />
                        <path
                            d="M8.5848 18.458C4.83034 13.717 -1.46276 2.2043 16.0011 2.2043C33.4632 2.2043 27.1731 13.7145 23.4186 18.4564C22.7044 16.4418 21.2808 15.0534 19.233 14.377C20.277 12.4681 20.8045 10.9997 20.9887 9.45708C19.0618 9.06947 17.5451 8.90068 16.0011 8.92167C14.4571 8.90068 12.9404 9.06947 11.0135 9.45708C11.1978 10.9999 11.7253 12.4683 12.7695 14.3775C10.7219 15.0543 9.29852 16.4429 8.5848 18.458Z"
                            stroke="#313B6B"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M13.0774 2.33711C11.985 3.26416 10.6072 6.04124 11.0122 9.45734"
                            stroke="#313B6B"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M18.9242 2.33711C20.0166 3.26416 21.3944 6.04124 20.9895 9.45734"
                            stroke="#313B6B"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M16.0005 29.7945C21.0854 29.7945 23.9456 26.9343 23.9456 21.8494C23.9456 16.7645 21.0854 13.9043 16.0005 13.9043C10.9157 13.9043 8.05542 16.7645 8.05542 21.8494C8.05542 26.9343 10.9157 29.7945 16.0005 29.7945Z"
                            fill="white"
                        />
                        <path
                            d="M16.0005 29.7945C21.0854 29.7945 23.9456 26.9343 23.9456 21.8494C23.9456 16.7645 21.0854 13.9043 16.0005 13.9043C10.9157 13.9043 8.05542 16.7645 8.05542 21.8494C8.05542 26.9343 10.9157 29.7945 16.0005 29.7945Z"
                            stroke="#313B6B"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M17.7084 19.6261C17.5931 19.1601 17.4453 18.7284 17.2583 18.3221C16.7521 17.2215 15.256 17.2213 14.7487 18.3213C14.5613 18.7279 14.413 19.1598 14.2977 19.6261C13.8458 19.61 13.4107 19.6257 12.9853 19.6763C11.7614 19.8219 11.2612 21.2567 12.1748 22.084C12.4933 22.3724 12.847 22.6326 13.243 22.8718C13.0981 23.2674 12.9868 23.659 12.9071 24.0522C12.6562 25.2897 13.9036 26.232 14.994 25.5949C15.3407 25.3925 15.6745 25.1548 16.002 24.8778C16.3298 25.1552 16.6643 25.3931 17.0118 25.5958C18.1026 26.232 19.3499 25.2897 19.099 24.0522C19.0193 23.659 18.908 23.2674 18.763 22.8718C19.159 22.6326 19.5128 22.3724 19.8313 22.084C20.7449 21.2567 20.2446 19.8219 19.0208 19.6763C18.5954 19.6257 18.1603 19.61 17.7084 19.6261Z"
                            fill="#B6C0F3"
                        />
                        <path
                            d="M17.7084 19.6261C17.5931 19.1601 17.4453 18.7284 17.2583 18.3221C16.7521 17.2215 15.256 17.2213 14.7487 18.3213C14.5613 18.7279 14.413 19.1598 14.2977 19.6261C13.8458 19.61 13.4107 19.6257 12.9853 19.6763C11.7614 19.8219 11.2612 21.2567 12.1748 22.084C12.4933 22.3724 12.847 22.6326 13.243 22.8718C13.0981 23.2674 12.9868 23.659 12.9071 24.0522C12.6562 25.2897 13.9036 26.232 14.994 25.5949C15.3407 25.3925 15.6745 25.1548 16.002 24.8778C16.3298 25.1552 16.6643 25.3931 17.0118 25.5958C18.1026 26.232 19.3499 25.2897 19.099 24.0522C19.0193 23.659 18.908 23.2674 18.763 22.8718C19.159 22.6326 19.5128 22.3724 19.8313 22.084C20.7449 21.2567 20.2446 19.8219 19.0208 19.6763C18.5954 19.6257 18.1603 19.61 17.7084 19.6261Z"
                            stroke="#313B6B"
                            stroke-width="2"
                            stroke-linejoin="round"
                        />
                    </g>
                </svg>
            }
            title={'Badges Created'}
            value={dashStates?.activeBadges}
        />,
        <DashboardInfoCard
            icon={
                <svg
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="56" height="56" rx="28" fill="#E5EAF9" />

                    <g transform="translate(12, 12)">
                        <path
                            d="M20.8032 10.5885C20.1368 7.88295 19.083 5.58615 17.4867 3.48033C16.7335 2.48682 15.2719 2.48683 14.5182 3.47995C12.9201 5.58587 11.8624 7.88278 11.1959 10.5885C8.48555 10.4916 5.9897 10.8028 3.51527 11.6049C2.3113 11.9951 1.8217 13.4092 2.53811 14.4562C4.0226 16.6258 5.85543 18.3312 8.22523 19.7687C7.3063 22.2867 6.86818 24.7471 6.84182 27.3297C6.82854 28.6311 8.05042 29.5617 9.28827 29.1752C11.755 28.4053 13.9209 27.2047 15.9966 25.4423C18.0725 27.2049 20.2421 28.4055 22.7109 29.1754C23.9488 29.5617 25.1706 28.6311 25.1572 27.3297C25.1309 24.7471 24.6929 22.2867 23.7739 19.7687C26.1437 18.3312 27.9765 16.6258 29.461 14.4562C30.1775 13.4092 29.6879 11.9951 28.4839 11.6049C26.0095 10.8028 23.5135 10.4916 20.8032 10.5885Z"
                            fill="#B6C0F3"
                        />
                        <path
                            d="M20.8032 10.5885C20.1368 7.88295 19.083 5.58615 17.4867 3.48033C16.7335 2.48682 15.2719 2.48683 14.5182 3.47995C12.9201 5.58587 11.8624 7.88278 11.1959 10.5885C8.48555 10.4916 5.9897 10.8028 3.51527 11.6049C2.3113 11.9951 1.8217 13.4092 2.53811 14.4562C4.0226 16.6258 5.85543 18.3312 8.22523 19.7687C7.30631 22.2867 6.86818 24.7471 6.84182 27.3297C6.82854 28.6311 8.05042 29.5617 9.28827 29.1752C11.755 28.4053 13.9209 27.2047 15.9966 25.4423C18.0725 27.2049 20.2421 28.4055 22.7109 29.1754C23.9488 29.5617 25.1706 28.6311 25.1572 27.3297C25.1309 24.7471 24.6929 22.2867 23.7739 19.7687C26.1437 18.3312 27.9765 16.6258 29.461 14.4562C30.1775 13.4092 29.6879 11.9951 28.4839 11.6049C26.0095 10.8028 23.5135 10.4916 20.8032 10.5885Z"
                            stroke="#313B6B"
                            stroke-width="2"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M16.0008 21.0395L16.0008 15.1004C16.0008 14.1632 15.2411 13.4035 14.3039 13.4035H13.4554M16.0008 21.0395L18.5471 21.0394M16.0008 21.0395L13.4565 21.0394"
                            stroke="#313B6B"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </g>
                </svg>
            }
            title={'Badges Won'}
            value={dashStates?.badgeWinnerCount}
        />
    ];
    const handleShowBadge = (rowData) => {
        setClickedRowId(rowData?._id);
        setClickedCompanyBadges(rowData?.badges);
    }

    const columns = [
        {
            title: 'Name',
            key: 'name',
            sortable: false,
            align: 'left',
            type: 'profileWithName'
        },
        {
            title: 'Gender',
            key: 'gender',
            sortable: false,
            align: 'left',
            type: 'text3',
        },
        {
            title: 'Badges Won',
            key: 'badgeCount',
            sortable: false,
            align: 'center',
            type: 'number',
        },
        {
            title: '',
            key: 'action',
            align: 'left',
            // isNavigate: true,
            // navigateUrl: '/user',
            arrowClickFun: handleShowBadge,
            type: 'action',
        }
    ];
    const badgesColumns = [
        {
            title: 'Name',
            key: 'title',
            sortable: false,
            align: 'left',
            type: 'profileWithName'
        },
    ];

    const fetchData = async (page) => {
        setLoader(true);
        try {
            let response;
            if (userData && (userData.userType === 3 || userData.userType === 4)) {
                response = await CompanyApi.getCompanyUsers(page, searchTerm, startDate, recordsPerPage);
            } else {
                response = await Api.getB2CUsers(page, searchTerm, startDate, recordsPerPage);
            }

            if (response?.data?.success === true) {
                setCompanyUsers(response.data.data || []);
                setCurrentPage(response.data.meta?.page || 1);
                setTotalCount(response.data.totalRecords || 0);
            } else if (response?.status === 401) {
                errorToast(response?.message || "Unauthorized");
            } else if (response?.status === 0) {
                setCurrentPage(1);
                setTotalCount(0);
                setCompanyUsers([]);
                errorToast(response?.message || "Something went wrong");
            }
        } catch (error) {
            errorToast("An unexpected error occurred.");
            console.error("fetchData error:", error);
        } finally {
            setApiCall(false);
            setLoader(false);
        }
    };

    useEffect(() => {
        const fetchDashState = async () => {
            try {
                let response;
                if (userData && (userData.userType === 3 || userData.userType === 4)) {
                    response = await CompanyApi.getCompanyBadgeDashboardState();
                } else {
                    response = await Api.getAdminBadgeDashboardState();
                }

                if (response?.data?.status === 'success') {
                    setDashStates(response.data.data || {});
                }
            } catch (error) {
                console.error("fetchDashState error:", error);
            }
        };

        fetchDashState();
    }, []);

    useEffect(() => {
        if (apiCall) {
            fetchData(currentPage)
        }
    }, [])

    useEffect(() => {
        if (!apiCall) {
            if (debounceTimeout) clearTimeout(debounceTimeout);
            const timeout = setTimeout(() => {
                fetchData(currentPage)
            }, 100);
            setDebounceTimeout(timeout);
        }
    }, [searchTerm, startDate])

    return (
        <div className="relative lg:pl-5 lg:mb-[45px]">
            <Helmet>
                <meta charSet="utf-8" />
                <title>Badges & Wellpoints | Shoorah Admin</title>
            </Helmet>
            {loader ? <Loader /> : null}
            <Topbar title={'Badges & Wellpoints'} />
            {/* <Breadcrumb pageList={pages} className="lg:mt-8" /> */}

            <div className="sm:flex flex-col md:flex-row justify-between items-center gap-3 mt-3">
                {/* Left-aligned search input */}
                <div className="flex items-center justify-center w-full sm:w-auto">
                    <SearchInput
                        id="searchKey"
                        name="searchKey"
                        type="text"
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                        }}
                        placeholder="Search"
                        className="w-full sm:w-auto px-3 py-2"
                    />
                </div>
                {/* Right-aligned calander and create badge button */}
                <div className="flex flex-col sm:flex-row items-center justify-center mt-2 sm:mt-0 space-y-2 sm:space-y-0 sm:space-x-2 w-full sm:w-auto">
                    <div ref={ref2} className="relative inline-block text-left w-60 sm:w-auto">
                        <button
                            type="button"
                            onClick={() => setIsOpen2(!isOpen2)}
                            className="flex justify-between items-center w-full sm:w-auto px-5 py-2 text-xs sm:text-base font-medium border dark:border-text-shoorah-darkBg border-[#0B1D2E] rounded-full dark:text-shoorah-darkBg dark:border-shoorah-darkBg"
                        >
                            <span>
                                {startDate ? `${new Date(startDate).toLocaleDateString()}` : 'Date Created'}
                            </span>
                            {selectedTheme ? (
                                <>
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                                            stroke="#F3F4F6"
                                            stroke-miterlimit="10"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </>
                            ) : (
                                <>
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                                            stroke="#0B1D2E"
                                            stroke-miterlimit="10"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </>
                            )}
                        </button>
                        {isOpen2 && (
                            <div
                            className="absolute z-10 p-2 mt-2 right-0 w-full sm:w-auto
                              bg-white shadow-lg ring-1 ring-[#E7EAE8] dark:bg-shoorah-darkBgColor
                           rounded-md transform scale-90 sm:scale-100 overflow-auto"
                                // className="absolute sm:-top-2 top-0 md:-left-40 sm:-left-10 left-0 w-full sm:w-auto transform scale-90 sm:scale-100 z-10 mt-1 p-2 bg-white shadow-lg ring-1 ring-[#E7EAE8] dark:bg-shoorah-darkBgColor rounded-md"
                                ref={calendarRef}
                            >
                                <div className="bg-white dark:bg-shoorah-darkBgColor text-[14px]">
                                    <Calendar
                                        className={'calendar text-sm sm:text-lg'}
                                        onChange={handleChangeC}
                                        nextLabel={
                                            <button className="custom-next-button flex justify-center items-center">
                                                <ChevronRightIcon className="w-8 h-8" />
                                            </button>
                                        }
                                        maxDate={new Date()}
                                        prevLabel={
                                            <button className="custom-prev-button flex justify-center items-center">
                                                <ChevronLeftIcon className="w-8 h-8" />
                                            </button>
                                        }
                                        date={startDate ? new Date(startDate) : new Date()}
                                        navigationLabel={({ date }) => (
                                            <button
                                                style={{ cursor: 'default', pointerEvents: 'none' }}
                                                className="text-base"
                                            >
                                                {date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
                                            </button>
                                        )}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    {/* {userData?.userType !== 3 && <div className="self-center inline-flex items-center justify-center w-64 sm:w-auto">
                        <Link
                            to={'/b2c-users/add-badge'}
                            className="font-medium px-5 py-2 bg-shoorah-active text-white rounded-full xl:text-[16px] text-[14px]"
                        >
                            Create Badge
                        </Link>
                    </div>} */}
                </div>
            </div>
            {/* Cards */}
            <div className="grid md:grid-cols-3 grid-cols-1 h-auto gap-4 mt-5">
                {subAdminStatusCards.map((item, index) => (
                    <React.Fragment key={index}>{item}</React.Fragment>
                ))}
            </div>
            {/* {userData?.userType !== 3 && <div className='w-100 bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl p-3 flex justify-between items-center mt-5'>
                <span>Active Badges</span>
                <ChevronRightIcon className="w-8 h-8 cursor-pointer" onClick={() => navigate('active-badges')} />
            </div>} */}
            <div className="grid grid-cols-12 mt-5 gap-4">
                <div className={`col-span-12 ${clickedCompanyBadges?.length > 0 && 'md:col-span-9'}`}>
                    <Table
                        columns={columns}
                        data={companyUsers}
                        name={'commpany_users'}
                        bottomBorder={totalCount > 10}
                        loader={loader}
                        setSearchTerm={(data) => setSearchTerm(data)}
                        activeRowId={clickedRowId}
                    />
                </div>
                {clickedCompanyBadges?.length > 0 && <div className="col-span-12 md:col-span-3 h-full">
                    <Table
                        columns={badgesColumns}
                        data={clickedCompanyBadges}
                        name={'company_badges'}
                        bottomBorder={totalCount > 10}
                        loader={loader}
                        setSearchTerm={(data) => setSearchTerm(data)}
                        activeRowId={null}
                    />
                </div>}
            </div>
            <div className='mt-5'>
                {totalCount > recordsPerPage ? (
                    <Pagination
                        currentPage={currentPage}
                        totalCount={totalCount}
                        pageSize={recordsPerPage}
                        onPageChange={(page) => {
                            setCurrentPage(page)
                            fetchData(page)
                        }}
                    />
                ) : (
                    <span />
                )}
            </div>
        </div>
    )
}

export default B2cUsers